<template>
  <div class="flex items-center">
    <popup v-if="showPopup" :popup="popupData" @close="handleOk" />
    <base-table
      :title="$t('forms.userGroup.titlePlural')"
      :records="records"
      @update:records="(val) => (records = val)"
      :table-columns="tableColumns"
      @update:table-columns="(val) => (tableColumns = val)"
      @add-row="addRow"
      @edit-row="editRow"
      @view-row="viewRow"
      @delete-row="deleteRow"
      @pageChanged="onPageChange"
      @reload-page="searchInList({ search: null })"
      @search="searchInList"
      :lang-dict="langDict"
    />
  </div>
</template>
<script>
import Popup from "@/components/Cards/Popup.vue";
import BaseTable from "@/components/Cards/BaseTable";
import { mapActions, mapGetters } from "vuex";
import { baseMixin } from "@/mixins/base";

export default {
  components: {
    BaseTable,
    Popup,
  },
  data() {
    return {
      records: [],
      tableColumns: [],
      langDict: "forms.userGroup.tableColumns",
    };
  },
  async created() {
    await this.searchInList({ search: null });
  },
  mixins: [baseMixin],
  computed: {
    ...mapGetters(["getPageSize", "getPage"]),
  },
  methods: {
    ...mapActions([
      "getGroupList",
      "setTableColumns",
      "setGroupList",
      "setPage",
      "setCount",
      "setShowOverlay",
      "deactivateUserGroup",
    ]),
    async addRow() {
      this.$router.push({ name: "AddUserGroup" });
    },
    async editRow(id) {
      this.$router.push({ name: "EditUserGroup", params: { id } });
    },
    async viewRow(id) {
      this.$router.push({ name: "ViewUserGroup", params: { id } });
    },
    async deleteRow(id) {
      try {
        const res = await this.deactivateUserGroup({ id });

        if (res.status >= 200 && res.status < 300) {
          this.popupData = {
            type: "success",
            message: "La operación se completó con éxito",
          };
        }
        this.showPopup = true;
      } catch (err) {
        this.popupData = {
          type: "error",
          message: err,
        };
        this.showPopup = true;
      } finally {
        this.search = null;
        this.searchInList({ search: this.search });
        this.setShowOverlay(false);
      }
    },
    async searchInList({ search }) {
      this.setShowOverlay(true);
      const res = await this.getGroupList({
        search: search,
        page: this.page,
        pageSize: this.getPageSize,
      });

      if (res.status == 200) {
        const { results, tableColumns, count } = await res.json();

        this.records = results;
        this.tableColumns = tableColumns;
        this.setCount(count);
        this.setGroupList(this.records);
        this.setTableColumns(tableColumns);
      }
      this.setShowOverlay(false);
    },
    async onPageChange(page) {
      this.setPage(page);
      await this.searchInList({ search: null });
    },
  },
};
</script>
